import 'angular';

import { ExportCtrl }                 from './export';
import { ExportEmailCustomerCtrl }    from './export.email-customer';
import { ExportEmailInvoiceCtrl }     from './export.email-invoice';
import { ExportEmailInvoiceItemCtrl } from './export.email-invoice-item';
import { ExportEmailProductCtrl }     from './export.email-product';
import { ExportEmailVehicleCtrl }     from './export.email-vehicle';
import { ExportEmailVendorCtrl }      from './export.email-vendor';
import { ExportStates }               from './export.states.ajs';

angular.module('workshop.export', [])
  .config(ExportStates)
  .controller('emailCustomerExportCtrl', ExportEmailCustomerCtrl)
  .controller('emailInvoiceExportCtrl', ExportEmailInvoiceCtrl)
  .controller('emailInvoiceItemExportCtrl', ExportEmailInvoiceItemCtrl)
  .controller('emailProductExportCtrl', ExportEmailProductCtrl)
  .controller('emailVendorExportCtrl', ExportEmailVendorCtrl)
  .controller('emailVehicleExportCtrl', ExportEmailVehicleCtrl)
  .controller('exportCtrl', ExportCtrl)